import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { isDefined } from '@fi-shared/utils';
import { FileType } from '@fi-shared/types';

interface FiHistoryChecklistDetailsAnswersDownloadDialogData {
    pagesCount: number;
}

interface FiHistoryChecklistDetailsAnswersDownloadDialogResult {
    isFullReport: boolean;
    reportFormat: FileType;
}

@Component({
    selector: 'fi-history-checklist-details-answers-download-dialog',
    templateUrl: './answers-download-dialog.component.html',
    styleUrls: ['./answers-download-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-history-checklist-details-answers-download-dialog' },
    standalone: false,
})
export class FiHistoryChecklistDetailsAnswersDownloadDialogComponent extends FiDialogsContentBase<
    FiHistoryChecklistDetailsAnswersDownloadDialogData,
    FiHistoryChecklistDetailsAnswersDownloadDialogResult
> {
    isFullReport: boolean = false;
    reportFormat: FileType = FileType.Pdf;

    isYesButtonDisabled(): boolean {
        return !isDefined(this.isFullReport) || !isDefined(this.reportFormat);
    }

    protected showPageSelection() {
        return this.data.pagesCount > 1;
    }

    getResult(): FiHistoryChecklistDetailsAnswersDownloadDialogResult {
        return {
            isFullReport: this.isFullReport,
            reportFormat: this.reportFormat,
        };
    }

    protected readonly FileType = FileType;
}
